
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chuyen-khoa",
      function () {
        return require("private-next-pages/chuyen-khoa/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chuyen-khoa"])
      });
    }
  